import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carrentalserviceinpune() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Pune',
    heading: 'Aaryan Travels: Corporate Cab Services in Pune',
    headingDescription: ' Aaryan Travels specializes in premium Corporate Cab Services in Pune, designed for business professionals, executives, and corporate organizations seeking reliable transportation. Whether it’s daily employee commute, client pickups, intercity transfers, or multi-day business trips, our fleet of sedans, SUVs, luxury cars, and tempo travellers ensures a smooth and professional travel experience. With uniformed chauffeurs, GPS-enabled vehicles, and strict punctuality standards, we guarantee secure and hassle-free corporate travel across Pune. From IT parks to manufacturing hubs, Aaryan Travels provides tailored corporate cab solutions with monthly billing, dedicated support, and 24/7 availability for meetings, airport transfers, and factory visits.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

    "topPlaces": [
      {
        "title": "Shaniwar Wada",
        "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
      },
      {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
      },
      {
        "title": "Sinhagad Fort",
        "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
      },
      {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
      },
      {
        "title": "Pataleshwar Cave Temple",
        "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
      },
      {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
      },
      {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
      },
      {
        "title": "Osho Ashram",
        "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
      },
      {
        "title": "Pu La Deshpande Garden",
        "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
      },
      {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
      }
    ],


    "services": [
  {
    "name": "Corporate Cab Services in Pune",
    "description": "Experience professional and reliable Corporate Cab Services in Pune tailored for businesses. We offer clean vehicles, punctual service, and corporate-grade comfort for executives and employees alike."
  },
  {
    "name": "Pune Corporate Taxi",
    "description": "Book Pune Corporate Taxi services designed to meet the needs of modern businesses. Ideal for business meetings, office commutes, and executive transfers across the city."
  },
  {
    "name": "Business Cab Hire Pune",
    "description": "Hire business cabs in Pune for seamless and timely transportation. Our Business Cab Hire service is perfect for daily commutes, industrial visits, and professional travel needs."
  },
  {
    "name": "Corporate Vehicle Rental Pune",
    "description": "Rent corporate vehicles in Pune on an hourly, daily, or monthly basis. Choose from a wide range of sedans, SUVs, and luxury cars suitable for business use."
  },
  {
    "name": "Corporate Cab Booking Pune",
    "description": "Easily book corporate cabs in Pune with our efficient online and phone booking options. Ensure smooth travel for your teams with professional drivers and reliable scheduling."
  },
  {
    "name": "Employee Transport Services Pune",
    "description": "Streamline your workforce commute with our Employee Transport Services in Pune. We provide punctual pickups, verified drivers, and optimized routing for office staff and industrial workers."
  },
  {
    "name": "Monthly Corporate Cabs Pune",
    "description": "Subscribe to our Monthly Corporate Cabs in Pune for uninterrupted daily transport. Ideal for companies seeking consistent and dependable employee mobility solutions."
  },
  {
    "name": "Affordable Corporate Cab Pune",
    "description": "Get budget-friendly yet quality corporate cab services in Pune. Our pricing plans ensure maximum value without compromising on safety or service standards."
  },
  {
    "name": "Best Corporate Cab Pune",
    "description": "Choose the Best Corporate Cab service in Pune for executive-class vehicles, trained chauffeurs, and superior reliability. Trusted by top companies for business transport."
  },
  {
    "name": "Corporate Chauffeur Service Pune",
    "description": "Travel in style with our Corporate Chauffeur Service in Pune. Our professional drivers offer a discreet and premium experience for senior executives and VIP clients."
  },
  {
    "name": "Corporate Car Rental Pune",
    "description": "Flexible Corporate Car Rental in Pune with multiple vehicle options. Rent luxury, mid-size, or economy cars for your short- or long-term corporate needs."
  },
  {
    "name": "Office Cab Services Pune",
    "description": "Ensure timely employee pickups and drop-offs with our Office Cab Services in Pune. Perfect for IT parks, BPOs, and other office-based organizations."
  },
  {
    "name": "Corporate Taxi Solutions Pune",
    "description": "End-to-end Corporate Taxi Solutions in Pune designed for modern businesses. Includes invoicing, GPS tracking, and priority dispatch for smooth operations."
  },
  {
    "name": "Pune Corporate Car Hire",
    "description": "Hire cars for corporate use in Pune with flexible plans and experienced drivers. Our Corporate Car Hire is ideal for day-long meetings, city tours, or airport runs."
  },
  {
    "name": "Corporate Travel Cabs Pune",
    "description": "Plan seamless corporate travel within and outside Pune with our Corporate Travel Cabs. Reliable service, comfortable vehicles, and punctual schedules guaranteed."
  }
],
"tableData": [
  ["Corporate Cab Services in Pune", "Pune Corporate Taxi"],
  ["Business Cab Hire Pune", "Corporate Vehicle Rental Pune"],
  ["Corporate Cab Booking Pune", "Employee Transport Services Pune"],
  ["Monthly Corporate Cabs Pune", "Affordable Corporate Cab Pune"],
  ["Best Corporate Cab Pune", "Corporate Chauffeur Service Pune"],
  ["Corporate Car Rental Pune", "Office Cab Services Pune"],
  ["Corporate Taxi Solutions Pune", "Pune Corporate Car Hire"],
  ["Corporate Travel Cabs Pune", "—"]
],


    "whychoose": [
  {
    "WhyChooseheading": "Professional Corporate Cab Services in Pune",
    "WhyChoosedescription": "Aaryan Travels specializes in reliable and punctual corporate cab services across Pune, ensuring seamless transportation for business needs."
  },
  {
    "WhyChooseheading": "On-Time Pickup and Drop for Office Commutes",
    "WhyChoosedescription": "Our trained drivers ensure timely pickups and drops, making daily office commutes smooth and hassle-free for employees."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Business-Class Comfort",
    "WhyChoosedescription": "Travel in clean, air-conditioned vehicles equipped for maximum comfort and a professional travel experience."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Corporates",
    "WhyChoosedescription": "Aaryan Travels offers tailored solutions with dedicated support for managing corporate travel requirements efficiently."
  },
  {
    "WhyChooseheading": "Transparent Billing and Corporate Invoicing",
    "WhyChoosedescription": "We provide clear, GST-compliant invoices and competitive pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Availability for Business Travel Needs",
    "WhyChoosedescription": "Our corporate cab services are available round the clock to accommodate early morning meetings or late-night airport transfers."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans for Meetings and Events",
    "WhyChoosedescription": "Choose from hourly rentals, full-day bookings, or intercity rides for corporate meetings, site visits, or business events."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Business Need",
    "WhyChoosedescription": "From sedans to luxury cars and tempo travellers, we offer vehicles suited for individual executives or larger corporate groups."
  }
]























  }

  const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services in Pune?',
    answer: 'Yes, Aaryan Travels provides professional and reliable corporate cab services across Pune, catering to business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Pune with Aaryan Travels?',
    answer: 'You can book our corporate cabs through our official website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Pune?',
    answer: 'Aaryan Travels offers a wide fleet including sedans, SUVs, and premium cars suitable for executive and employee transportation.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute?',
    answer: 'Yes, we offer customized corporate cab solutions for daily employee pickups and drops across Pune.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and well-versed with corporate travel standards in Pune.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group cab bookings for corporate events in Pune?',
    answer: 'Yes, we specialize in managing group transportation and bulk cab bookings for corporate meetings, events, and conferences.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for corporate cab services?',
    answer: 'Yes, we provide flexible billing options including monthly invoicing for our corporate clients.',
  },
  {
    question: 'Is your corporate cab service in Pune available 24x7?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services to ensure seamless business travel.',
  },
  {
    question: 'What safety measures are in place for corporate cab services in Pune?',
    answer: 'All vehicles undergo regular sanitization and safety checks, and our drivers follow strict safety protocols.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings?',
    answer: 'Yes, we allow full customization of pickup and drop points based on your corporate travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'Aaryan Travels’ corporate cab service in Pune is always punctual and professional. Perfect for our employee transport needs.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Mehta',
    feedback: 'We’ve been using Aaryan Travels for our company’s daily commute in Pune. Reliable service and excellent support!',
    rating: 5,
  },
];













































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Pune",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-pune.jpg",  // example image path, you can replace with actual image URL
  "description": "Reliable and affordable corporate cab services in Pune for business travel, employee transport, monthly rentals, and chauffeur services. Book corporate taxis for your office commute and business needs with Aaryan Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, adjust as needed
    "ratingCount": "4500", // example count, adjust as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-pune"
  }
};




  return (
    <div>


<Helmet>
  <title>Corporate Cab Services in Pune | Business Taxi & Employee Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable corporate cab services in Pune for business travel, employee transport, monthly rentals, and chauffeur services. Book corporate taxis for your office commute and business needs with Aaryan Travels."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in Pune, Pune Corporate Taxi, Business Cab Hire Pune, Corporate Vehicle Rental Pune, Corporate Cab Booking Pune, Employee Transport Services Pune, Monthly Corporate Cabs Pune, Affordable Corporate Cab Pune, Best Corporate Cab Pune, Corporate Chauffeur Service Pune, Corporate Car Rental Pune, Office Cab Services Pune, Corporate Taxi Solutions Pune, Pune Corporate Car Hire, Corporate Travel Cabs Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carrentalserviceinpune;